module.exports = __webpack_public_path__ + "static/img/中航证券.b1187ee.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/中航证券.png
// module id = IvnU
// module chunks = 3